import { RouteParameters } from "./route-parameters";

const WEIGHT_AND_BALANCE_ROUTING = {
  CONFIGURE: {
    AIRPLANE_CONFIG: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/configure/airplane-config`,
    EMPTY_WEIGHT_AND_CG: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/configure/empty-weight-and-cg`,
    EMPTY_WEIGHT_AND_CG_EQUIPMENT_LIST: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/configure/empty-weight-and-cg/equipment-list`,
    PILOT_WORKSHEET: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/configure/pilot-worksheet`,
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/configure`,
  },
  CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/create`,
  EQUIPMENT_LIST: {
    COPY_FROM_AIRPLANE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/equipment-list/copy-from-airplane`,
    COPY_FROM_LIST: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/equipment-list/copy-from-list`,
    CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/equipment-list/create`,
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/equipment-list`,
  },
  REPORT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/report`,
  ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b`,
  SAVED_W_AND_CG: {
    CREATE: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/saved-w-and-cg/create`,
    ROOT: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/saved-w-and-cg`,
  },
  VIEW: `/dashboard/:${RouteParameters.AIRPLANE_ID}/operations/w-and-b/view`,
} as const;

const WEIGHT_AND_BALANCE_ROUTES = [
  WEIGHT_AND_BALANCE_ROUTING.ROOT,
  WEIGHT_AND_BALANCE_ROUTING.CREATE,
  WEIGHT_AND_BALANCE_ROUTING.REPORT,
  WEIGHT_AND_BALANCE_ROUTING.VIEW,
  WEIGHT_AND_BALANCE_ROUTING.CONFIGURE.AIRPLANE_CONFIG,
  WEIGHT_AND_BALANCE_ROUTING.CONFIGURE.EMPTY_WEIGHT_AND_CG,
  WEIGHT_AND_BALANCE_ROUTING.CONFIGURE.EMPTY_WEIGHT_AND_CG_EQUIPMENT_LIST,
  WEIGHT_AND_BALANCE_ROUTING.EQUIPMENT_LIST.ROOT,
  WEIGHT_AND_BALANCE_ROUTING.EQUIPMENT_LIST.CREATE,
  WEIGHT_AND_BALANCE_ROUTING.EQUIPMENT_LIST.COPY_FROM_LIST,
  WEIGHT_AND_BALANCE_ROUTING.EQUIPMENT_LIST.COPY_FROM_AIRPLANE,
  WEIGHT_AND_BALANCE_ROUTING.SAVED_W_AND_CG.ROOT,
  WEIGHT_AND_BALANCE_ROUTING.SAVED_W_AND_CG.CREATE,
] as const;

export { WEIGHT_AND_BALANCE_ROUTES, WEIGHT_AND_BALANCE_ROUTING };
